import type {AppSpec, AppStruct, TriggerIntegrationSpec} from '@cohort/shared/schema/apps/app';
import {GarminConnectBeActiveTriggerIntegrationSpec} from '@cohort/shared/schema/apps/garmin-connect/triggers/beActive';
import {GarminConnectCompleteActivityTriggerIntegrationSpec} from '@cohort/shared/schema/apps/garmin-connect/triggers/completeActivity';
import type {GarminConnectUserConnectorStruct} from '@cohort/shared/schema/apps/garmin-connect/userConnector';
import {GarminConnectUserConnectorSpec} from '@cohort/shared/schema/apps/garmin-connect/userConnector';
import {GarminConnectActivityCreatedEventSpec} from '@cohort/shared/schema/apps/garmin-connect/userEvents/activityCreated';
import type {UserEventSpec, UserEventStruct} from '@cohort/shared/schema/apps/userEvent';

export const GarminConnectTriggerIntegrationSpecs = [
  GarminConnectBeActiveTriggerIntegrationSpec,
  GarminConnectCompleteActivityTriggerIntegrationSpec,
] as const satisfies ReadonlyArray<TriggerIntegrationSpec>;

type GarminConnectTriggerIntegrationIds =
  (typeof GarminConnectTriggerIntegrationSpecs)[number]['id'];

export const GarminConnectEventSpecs = [
  GarminConnectActivityCreatedEventSpec,
] as const satisfies ReadonlyArray<UserEventSpec<GarminConnectUserEventStruct>>;
type GarminConnectEventIds = (typeof GarminConnectEventSpecs)[number]['id'];

export type GarminConnectAppStruct = AppStruct<
  'garmin-connect',
  null,
  GarminConnectUserConnectorStruct,
  null,
  never,
  never,
  never,
  GarminConnectTriggerIntegrationIds,
  GarminConnectEventIds
>;

export const GarminConnectAppSpec: AppSpec<GarminConnectAppStruct> = {
  id: 'garmin-connect',
  name: 'GarminConnect',
  merchantConnector: null,
  userConnector: GarminConnectUserConnectorSpec,
  usersSyncSpec: null,
  actionSpecs: [],
  notificationIntegrationSpecs: [],
  perkIntegrationSpecs: [],
  triggerIntegrationSpecs: GarminConnectTriggerIntegrationSpecs,
  userEventSpecs: GarminConnectEventSpecs,
};

type GarminConnectEventResource = 'activity';
type GarminConnectUserEventId = `garmin-connect.${GarminConnectEventResource}.${string}`;
export type GarminConnectUserEventStruct = UserEventStruct<GarminConnectUserEventId, unknown>;
